module.exports = __webpack_public_path__ + "static/img/icon-nologin-wechat.9e991dd8.png";